import { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom"
import Form from 'react-bootstrap/Form';
import { getAppViewMode, setAppViewMode } from 'shared/components/App/Auth'
import getPages from 'utils/getPages'
import loadPages from 'utils/loadPages'
import { getCustomData } from 'shared/components/App/Auth'
import Store from 'redux/Store'
import { setFilterValues } from 'redux/actions'
import { setMenuPages } from 'shared/redux/actions'

interface LayoutSwitcherProps {
    store: any
}

const LayoutSwitcher: React.FunctionComponent<LayoutSwitcherProps> = (props: LayoutSwitcherProps) => {

    const [isAdmin, setIsAdmin] = useState<boolean>(true)

    const navigate = useNavigate()
    const viewMode = props.store.getState().viewMode?.mode

    useEffect(() => {
        const newIsAdmin = getAppViewMode() !== 'user'
        setIsAdmin(newIsAdmin)
    }, [viewMode])

    const changeViewMode = () => {
        const lastUrl = props.store.getState().lastUrl?.lastUrl
        let overrideUrl: string | false = false
        const viewMode= !isAdmin ? 'super admin' : 'user'
        const newIsAdmin = !isAdmin
        setIsAdmin(newIsAdmin)
        setAppViewMode(viewMode)

        if (!newIsAdmin) {
            loadPages({
                role: getCustomData('role'),
                customer: getCustomData('customer') ?? false,
                loadFromServer: true
            }).then((pages) => {
                Store.dispatch(setMenuPages(pages))
            })
        }

        // find a page to navigate to if empty
        if ((typeof lastUrl[viewMode] === 'undefined') || (lastUrl[viewMode] === '/login')) {
            const pages = getPages()
            const page = pages.find(item => {
                return item?.path && item.path.length &&
                    item?.roles && item.roles.includes(viewMode)
            })
            if (page)
                overrideUrl = page.path
        }

        // remove stored filter values
        Store.dispatch(setFilterValues({}))
    
        const navLastUrl = overrideUrl ? overrideUrl : lastUrl[viewMode]
        navigate(navLastUrl)
    }

    return <>
        <Form.Check
            type="switch"
            label={isAdmin ? 'Switch to User' : 'Switch to Admin'}
            onChange={changeViewMode}
            checked={isAdmin}
        />
    </>
}

export default LayoutSwitcher